import { Link } from 'react-router-dom'
import FrankCard from '../components/FrankCard'

// /404 — public, unauthed, full-viewport. Same "brand surface" pattern
// as /broken and /drink. Frank stands among broken cables looking
// genuinely confused about where you tried to go.
export default function NotFound() {
  return (
    <div className="crt-scanlines fixed inset-0 z-[150] bg-bg-primary text-text-primary overflow-auto">
      <div className="absolute inset-0 grid-backdrop pointer-events-none opacity-25" />
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full pointer-events-none"
        style={{
          background:
            'radial-gradient(circle, rgba(160,80,255,0.16) 0%, rgba(160,80,255,0.05) 35%, transparent 70%)',
          filter: 'blur(60px)',
        }}
      />

      <div className="relative z-10 min-h-full flex flex-col items-center justify-between px-6 py-10 md:py-16">
        {/* Header mark */}
        <div className="w-full max-w-4xl flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-xl bg-neon/10 border border-neon/30 flex items-center justify-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#39FF14"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 16.8l-6.2 4.5 2.4-7.4L2 9.4h7.6z" />
              </svg>
            </div>
            <div>
              <p className="brand-wordmark text-base text-neon neon-text leading-none">
                FRANKENVIBES <span className="text-text-primary">LAB</span>
              </p>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-text-muted mt-1">
                / synaptic bridge — not found
              </p>
            </div>
          </div>
          <Link
            to="/"
            className="font-mono text-[10px] uppercase tracking-[0.25em] text-text-muted hover:text-neon px-3 py-1.5 rounded-md border border-border hover:border-neon transition-colors cursor-pointer"
          >
            ← back to the lab
          </Link>
        </div>

        {/* Frank holding the broken cables */}
        <div className="flex flex-col items-center gap-8 py-12">
          <FrankCard
            src="frank-404.png"
            alt="Frank, holding two broken cables, very confused"
            badge="● bridge · not found"
            badgeKind="error"
            glow="error"
            size="lg"
          />

          <div className="max-w-2xl text-center space-y-4">
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-neon/70">
              / 404 · synaptic bridge severed
            </p>
            <h1 className="brand-wordmark text-5xl md:text-7xl leading-[1.05] text-text-primary">
              <span className="text-neon">404</span> — *darling*, that
              page does not exist.
            </h1>
            <p className="text-base md:text-lg text-text-secondary italic max-w-xl mx-auto leading-relaxed">
              Frank has been holding the cable for the last twenty seconds.
              He is very confused. The bridge to whatever you were looking
              for is, regrettably, *not where you left it*. Try{' '}
              <Link to="/" className="text-neon not-italic hover:underline">
                the lab
              </Link>
              .
            </p>
          </div>

          <div className="flex flex-wrap gap-3 justify-center">
            <Link
              to="/"
              className="px-5 py-2.5 text-sm font-semibold rounded-lg bg-neon text-bg-primary hover:bg-neon-dim transition-colors cursor-pointer"
            >
              Take me home
            </Link>
            <Link
              to="/gallery"
              className="px-5 py-2.5 text-sm font-semibold rounded-lg border border-border hover:border-neon hover:text-neon text-text-secondary transition-colors cursor-pointer"
            >
              Gallery
            </Link>
            <Link
              to="/drink"
              className="px-5 py-2.5 text-sm font-semibold rounded-lg border border-border hover:border-neon hover:text-neon text-text-secondary transition-colors cursor-pointer"
            >
              Pour something
            </Link>
          </div>
        </div>

        {/* Footer */}
        <div className="max-w-2xl text-center pt-6 space-y-2">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-text-muted">
            / the fine print
          </p>
          <p className="text-[11px] text-text-muted leading-relaxed italic">
            The page you wanted may have been deprecated, renamed,
            sacrificed for science, or eaten by Frank in a moment of stress.
            We are not currently accepting blame. The art director is on
            her second rooibos gin and is *unbothered*.
          </p>
        </div>
      </div>
    </div>
  )
}
